import { render, staticRenderFns } from "./foodSafety.vue?vue&type=template&id=0a3d3b52&scoped=true"
import script from "./foodSafety.vue?vue&type=script&lang=js"
export * from "./foodSafety.vue?vue&type=script&lang=js"
import style0 from "./foodSafety.vue?vue&type=style&index=0&id=0a3d3b52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d3b52",
  null
  
)

export default component.exports